<template>
  <div id="address">
    <div>
      <el-row>
        <el-col :span="12">
          <div>收货地址</div>
        </el-col>
        <el-col :span="12" align="right">
          <el-button type="text" @click="addFn()">
            <i class="fas fa-plus icon"></i>添加地址
          </el-button>
        </el-col>
      </el-row>
    </div>
    <div v-if="count>0">
      <div class="address-item" v-for="(item,key) of addressArr.results" :key="key">
        <el-row>
          <el-col :span="21">
            <div>收件人：{{item.name}}</div>
            <div>手机号：{{item.mobile}}</div>
            <div>收货地址：{{item.province+" "+item.city+" "+item.area+" "+item.address}}</div>
          </el-col>
          <el-col :span="3" align="right" style="padding-top: 15px">
            <div class="b1" v-if="item.id==defaultId">
              <el-button type="text" class="b1">默认地址</el-button>
            </div>
            <div v-else>
              <el-button
                type="text"
                class="b3"
                :loading="loadings[item.id]"
                @click="setDefault(item.id)"
              >设为默认地址</el-button>
            </div>
            <el-row>
              <el-col :span="12" class="b2">
                <el-button type="text" @click="canEdit(item.id)">编辑</el-button>
              </el-col>
              <el-col :span="12" class="b2" align="center">
                <el-button type="text" @click="delAddr(item.id)" v-if="item.id!=defaultId">删除</el-button>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </div>
    <div v-else class="lv3Text empty">
      <i class="fas fa-home fa-lg" style="margin-right:10px"></i>没有设置收货地址
    </div>
    <!--   -->
    <el-dialog title="添加收货地址" :visible.sync="addDialog" width="50%" @closed="handleClose">
      <div>
        <el-row :gutter="40" class="row">
          <el-col :span="12">
            <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
          </el-col>
          <el-col :span="12">
            <el-input v-model="form.a_mobile" placeholder="请输入手机号"></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="10" class="row">
          <el-col :span="8">
            <el-select v-model="form.province" placeholder="请选择" @change="change1">
              <el-option
                v-for="(item,index) in sel1"
                :key="index"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="8">
            <el-select v-model="form.city" placeholder="请选择" @change="change2">
              <el-option
                v-for="(item,index) in sel2"
                :key="index"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="8">
            <el-select v-model="form.area" placeholder="请选择">
              <el-option
                v-for="(item,index) in sel3"
                :key="index"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="24">
            <el-input type="textarea" v-model="form.address" placeholder="请输入详细地址"></el-input>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialog = false">取 消</el-button>
        <el-button type="primary" @click="submit" :loading="loading">确 定</el-button>
      </span>
    </el-dialog>
    <!--   -->
    <el-dialog title="编辑收货地址" :visible.sync="editDialog" width="50%">
      <div>
        <el-row :gutter="40" class="row">
          <el-col :span="12">
            <el-input v-model="editor.name" placeholder="请输入姓名"></el-input>
          </el-col>
          <el-col :span="12">
            <el-input v-model="editor.mobile" placeholder="请输入手机号"></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="10" class="row">
          <el-col :span="8">
            <el-select v-model="editor.province" placeholder="请选择" @change="change1">
              <el-option
                v-for="(item,index) in sel1"
                :key="index"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="8">
            <el-select v-model="editor.city" placeholder="请选择" @change="change2">
              <el-option
                v-for="(item,index) in sel2"
                :key="index"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="8">
            <el-select v-model="editor.area" placeholder="请选择">
              <el-option
                v-for="(item,index) in sel3"
                :key="index"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="24">
            <el-input type="textarea" v-model="editor.address" placeholder="请输入详细地址"></el-input>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitEdit" :loading="loading3">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      //
      serve : this.$store.state.serve,
      addressArr: [],
      addDialog: false,
      count: 0,
      form: {},
      options: {},
      sel1: null,
      sel2: null,
      sel3: null,
      loading: false,
      loading2: false,
      editor: {},
      editDialog: false,
      loading2: false,
      defaultId: null,
      loadings: [],
      editorId: 0,
      loading3: false
    }
  },
  activated() {
    this.$store.state.user_location = '地址管理'
  },
  created() {
    this.initData()
  },
  methods: {
    alert_success(message) {
      this.$message({
        message: message,
        type: 'success',
        offset: 200
      })
    },
    alert_error(message) {
      this.$message({
        message: message,
        type: 'error',
        offset: 200
      })
    },
    delAddr(id) {
      this.$confirm('此操作将永久删除该地址, 是否继续?', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      })
        .then(() => {
          const loading = this.$loading({
            lock: true,
            spinner: 'el-icon-loading',
            background: 'rgba(255,255,255 0.7)'
          })
          this.axios
            .get( this.serve + '/member/del_address', {
              params: {
                mobile: this.$cookies.get('user'),
                token: this.$cookies.get('token'),
                id: id
              }
            })
            .then(res => {
              this.loading2 = false
              loading.close()
              if (res.data.status == 'success') {
                this.initData()
                this.alert_success('删除成功!')
              } else {
                this.alert_error(res.data.msg)
              }
            })
        })
        .catch(() => {
          this.alert_error('删除取消')
        })
    },
    setDefault(id) {
      this.$set(this.loadings, id, true)
      this.axios
        .get(this.serve + '/member/set_default_address', {
          params: {
            mobile: this.$cookies.get('user'),
            token: this.$cookies.get('token'),
            id: id
          }
        })
        .then(res => {
          this.loading2 = false
          if (res.data.status == 'success') {
            this.initData()
          } else {
            this.alert_error(res.data.msg)
          }
        })
    },
    canEdit(id) {
      this.editorId = id
      var editor = {}
      for (var i of this.addressArr.results) {
        if (i.id == id) {
          editor = i
        }
      }
      this.editor = editor
      this.change1(editor.province)
      this.change2(editor.city)
      this.axios.get(this.serve + '/province').then(res => {
        this.sel1 = res.data
        this.editDialog = true
      })
    },
    submitEdit() {
      this.loading3 = true
      this.axios
        .get( this.serve + '/member/change_address_info', {
          params: {
            mobile: this.$cookies.get('user'),
            token: this.$cookies.get('token'),
            id: this.editorId,
            a_mobile: this.editor.mobile,
            province: this.editor.province,
            city: this.editor.city,
            area: this.editor.area,
            address: this.editor.address,
            name: this.editor.name
          }
        })
        .then(res => {
          this.loading3 = false
          if (res.data.status == 'success') {
            this.alert_success('收货地址已修改!')
            this.editDialog = false
            this.initData()
          } else {
            this.alert_error(res.data.msg)
          }
        })
    },
    initData() {
      this.axios
        .get( this.serve + '/member/get_address', {
          params: {
            mobile: this.$cookies.get('user'),
            token: this.$cookies.get('token')
          }
        })
        .then(res => {
          this.defaultId = res.data.data.default
          this.addressArr = res.data.data
          for (var i of this.addressArr.results) {
            this.loadings[i.id] = false
          }
          this.count = this.addressArr.results.length
        })
    },
    submit() {
      // return
      this.loading = true
      this.form.mobile = this.$cookies.get('user')
      this.form.token = this.$cookies.get('token')
      this.axios
        .get(this.serve + '/member/add_address', {
          params: this.form
        })
        .then(res => {
          if (res.data.status == 'success') {
            this.addDialog = false
            this.loading = false
            this.alert_success('添加一个新的收货地址')
            this.initData()
          } else {
            this.loading = false
            this.alert_error(res.data.msg)
          }
        })
    },
    change2(v) {
      this.axios.get(this.serve + '/area?name=' + v).then(res => {
        this.sel3 = res.data
      })
    },
    change1(v) {
      this.axios.get(this.serve + '/city?name=' + v).then(res => {
        this.sel2 = res.data
      })
    },
    addFn() {
      // if (this.count < 5) {
      this.axios.get(this.serve + '/province').then(res => {
        this.sel1 = res.data
        this.addDialog = true
      })
      // } else {
      //   this.alert_error('最多添加五个收货地址')
      // }
    },
    handleClose() {
      this.form = {}
    }
  }
}
</script>
<style lang="scss">
#address {
  min-height: 600px;
  .empty {
    padding: 20px 0;
  }
  .b2 {
    cursor: pointer;
  }
  .b2:hover {
    text-decoration: underline;
  }
  .b3 {
    display: block;
    background-color: #dddddd;
    width: 90%;
    margin: 0 auto;
    text-align: center;
    margin-bottom: 5px;
    color: #666;
    font-size: 12px;
    cursor: pointer;
  }
  .b3:hover {
    color: #333;
  }
  .b1 {
    cursor: pointer;
    font-size: 12px;
    display: block;
    background-color: #e2211c;
    width: 90%;
    margin: 0 auto;
    text-align: center;
    margin-bottom: 5px;
    color: #fff;
  }
  background-color: #fff;
  border: 1px solid #ddd;
  padding: 40px 20px;
  svg.icon {
    margin-right: 5px;
  }
  .address-item {
    line-height: 2em;
    border: 1px solid #ddd;
    padding: 15px;
    margin-bottom: 20px;
  }
  .row {
    margin-bottom: 20px;
  }
}
</style>